import { render } from "./TextArea.vue?vue&type=template&id=4623e7a2&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=4623e7a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4623e7a2"],['__file',"src/scripts/common/components/TextArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4623e7a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4623e7a2', __exports__)) {
    api.reload('4623e7a2', __exports__)
  }
  
  module.hot.accept("./TextArea.vue?vue&type=template&id=4623e7a2&scoped=true", () => {
    api.rerender('4623e7a2', render)
  })

}


export default __exports__